import { useToastStore } from '@/stores/Toast'
import ContextMenuItem from '../ContextMenuItem'
import { useDriverStore } from '@/stores/Drivers'

/**
 * DriverInfo context menu item.
 *
 * @author Alejandro Sanchez <asanchez@boltsystem.com>
 */
export default class DriverInfo extends ContextMenuItem {
    /**
     * Get the action callback function.
     *
     * @return {Function}
     */
    action() {
        return () => {
            const toastStore = useToastStore()
            const driverStore = useDriverStore()

            const id = this.params.node?.data?.drivers[0]?.id

            if (id) {
                return driverStore.setActive(id)
            }

            toastStore.setNotification({
                message: 'No driver found',
                type: 'error',
            })
        }
    }

    /**
     * Determine if the menu item should be enabled/disabled.
     *
     * @return {Boolean}
     */
    disabled() {
        const hasDrivers = this.params.node?.data?.drivers?.length > 0
        const selectedRows = this.params?.api?.getSelectedRows() || []

        return selectedRows.length > 1 || !hasDrivers
    }

    /**
     * The name of the menu item to display.
     *
     * @return {String}
     */
    name() {
        return 'Driver Info'
    }

    /**
     * The tooltip to display on hover.
     *
     * @return {String?}
     */
    tooltip() {
        return 'Click to change the truck of this column based on the selected value'
    }
}
